import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { WsLandingService } from 'src/app/ws/wsLanding/ws-landing.service';
import { MBannerImageListRequest, MBannerImageListResponseData, MCustomerMenuCategoryResponse, MGenderSupplimentRequest, MGetAllTagsResponse, MTrendingProductRequest } from './homepage.module';
import { lastValueFrom } from 'rxjs';
import { WsSubHeaderService } from 'src/app/ws/wsSubHeader/ws-sub-header.service';
import { Router } from '@angular/router';
import { MCommonListModalRequest, SharedPrefrences } from 'src/app/utils/utils.service';
import { MCustomerMenuListResponseData } from 'src/app/components/sub-header-category/sub-header-category.module';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { BroadCastService } from 'src/app/components/sub-header-hover-category/sub-header-hover-category.component';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { WsBrandService } from 'src/app/ws/wsBrand/ws-brand.service';
import { MGetSkinConcernResponse, MGetSkinTypeResponse } from '../individual-brand/individual-brand.module';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MBrandListModal, MGetBrandResponse, MGetProductRequest, MGetProductResponse } from '../product/product.module';
import { WsCheckoutService } from 'src/app/ws/wsCheckout/ws-checkout.service';
import { ToastrService } from 'ngx-toastr';
import { MCategoryResponseModal } from '../blog/blog.module';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent {
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  homeSlider: OwlOptions = {
    loop: true,
    margin: 30,
    autoplay: true,
    dots: true,
    nav: false,
    items: 1,
  }
  offerlebalSlider: OwlOptions = {
    loop: true,
    margin: 30,
    autoplay: false,
    dots: false,
    nav: false,
    items: 1,
  }
  mTrendingProductReq: MTrendingProductRequest = new MTrendingProductRequest();
  msupplimentReq: MGenderSupplimentRequest = new MGenderSupplimentRequest();
  mBannerReq: MBannerImageListRequest = new MBannerImageListRequest();
  images_banner: any = [];
  imagePreview_banner: any = [];
  images_skin_banner: any = [];
  imagePreview_skin_banner: any = [];
  images_suppliment_banner: any = [];
  imagePreview_suppliment_banner: any = [];
  customerMenuLists: any
  categorySkin: any = []
  categoryMakeup: any = []
  supplimentProducts: any;
  trendingProducts: any;
  categoryList: any = [];
  skinCareDescription = ""
  makeupDescription = ""
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mWishlistData: any = []
  selectedCategoryId: any;
  subCategoryList: any = []
  type: any;
  mGetSkinConcernResponse: MGetSkinConcernResponse = new MGetSkinConcernResponse()
  mGetSkinTypeResponse: MGetSkinTypeResponse = new MGetSkinTypeResponse()
  trendingBlogs: any = [];
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  getAlltags: any = [];
  hairSubCategoryList: any = [];
  mGetBrandResponse: MGetBrandResponse = new MGetBrandResponse()
  firstBrandList: any = [];
  secondBrandList: any = [];
  mGetProductRequest: MGetProductRequest = new MGetProductRequest()
  mGetProductResponse: any = new MGetProductResponse()
  makupProducts: any = [];
  categoryDetails: any = [];
  websiteconfigurations: any = [];
  website_configuration: any;
  home_first_text: any;
  some_text_cta: any;
  discountCatelogueList: any = [];
  allUnderDiscountCatelogue: any = [];
  offersDiscountCatelogue: any = [];
  tagsProducts: any = [];
  catName: any;
  userId: any = null;
  share: any;
  baseUrl: any = window.location.origin;
  currentUrl: any;
  hoveredBtn: string | null = null;
  hairCatId: any;
  categoryColor: any;
  @ViewChild('makeupProduct') makeupProduct!: ElementRef;
  @ViewChild('favProduct') favProduct!: ElementRef;
  @ViewChild('hairProduct') hairProduct!: ElementRef;
  @ViewChild('trendingblog') trendingblog!: ElementRef;
  showFavLeftArrow: boolean = true;
  showFavRightArrow: boolean = true;
  showMakeupLeftArrow: boolean = true;
  showMakeupRightArrow: boolean = true;
  showHairLeftArrow: boolean = true;
  showHairRightArrow: boolean = true;
  showTrendinLeftArrow: boolean = true;
  showTrendinRightArrow: boolean = true;
  isMobile: boolean = false;
  isMobileBanner: boolean = false;
  troubleSkinConcern: any;
  shopBySkinType: any;
  skinConcernList: any = [];
  skinTypeList: any = [];
  constructor(private router: Router, private wsBrandService: WsBrandService,
    private wslandingservice: WsLandingService, private wsblogservice: WsBlogService,
    private wsSubheaderService: WsSubHeaderService,
    private broadCastService: BroadCastService,
    private wsShopAllService: WsShopallService, private wsCheckoutService: WsCheckoutService,
    private _commonBehaviorChangeService: CommonBehaviorChangeService,
    private wsUserProfileService: WsUserProfileService,
    private modalService: NgbModal, private toast: ToastrService) {
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      this.makupProducts && this.makupProducts.length > 0 && this.makupProducts.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        } else {
          delete product.cartQty;
        }
      })
      this.tagsProducts && this.tagsProducts.length > 0 && this.tagsProducts.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        }
        else {
          delete product.cartQty;
        }
      })
    })

    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 991;
    this.isMobileBanner = window.innerWidth <= 575
  }
  async ngOnInit() {
    this.userId = SharedPrefrences.getUserId();
    await this.getAllTag();
    this.checkScreenSize()
    this.getCategoryList()
    if (this.isMobileBanner) {
      this.getBannerImages('home_top_banner_mobile');
    }
    else {
      this.getBannerImages('home_top_banner');
    }
    this.getCustomerMenuList();
    this.getAllWebsiteconfigurations()
    this.getSkinConcernList()
    this.getSkinTypeList()
    this.getAllBrand()
    this.getMakeupProducts();
    this.getFavouritesProducts();
    this.getAllModuleDataOfShopAll();
    this.getAllDiscountCatelogue();
    this.getTrendingBlogList()
    document.body.addEventListener('click', this.toggleShareBox.bind(this));
    setTimeout(() => {
      this.checkAllArrow()
    }, 8000);
  }

  /**
   * Hide Share Box on outside click
   * @param event 
   */
  toggleShareBox(event: Event): void {
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.share-icon');
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
  }

  ngOnDestroy() {
    document.body.removeEventListener('click', this.toggleShareBox.bind(this));

  }


  showShare(hide?: any) {
    if (hide == 'hide') {
      this.share = null;
    }
    else {
      if (this.share == hide.id) {
        this.share = null;
      }
      else {
        this.share = hide.id;
        this.currentUrl = decodeURI(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id)
      }
    }
  }


  clickToCopy(copy: any) {

    const blogData = this.baseUrl + "/individual-blog-updated/" + copy.title.split(' ').join('_') + '/' + copy.category_id + '/' + copy.id;

    // Create a dummy textarea element to perform the copying
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');

    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied');

    this.showShare('hide');
  }

  /**
 * Date:- 21-06-2023
 * Method :- This method is used to Get Order Detail List
 */
  async getWishList() {
    const wishList = this.wsUserProfileService.getWishList("" + SharedPrefrences.getUserId())
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
      }
    })
  }

  skinAndMakeupDescriotion() {
    this.broadCastService.getMessage().subscribe((data: MCustomerMenuListResponseData) => {
      let skin = data.categoryList?.filter((category) => category.id == 1)!
      this.skinCareDescription = skin[0].description!
      let makup = data.categoryList?.filter((category) => category.id == 2)!
      this.makeupDescription = makup[0].description!
    });
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get home_top_banner image
  * @param code :-  This param is used to get home_top_banner image
  */
  async getBannerImages(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imagebanner: MBannerImageListResponseData, i: any) => {
          let imgurl = imagebanner.path.replaceAll("\\", "/")
          this.imagePreview_banner.push(imgurl);
        })
      }
    })
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get home_skin_progress_banner image
  * @param code :-  This param is used to get home_skin_progress_banner image
  */
  async getSkinBannerImages(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imageskinbanner: MBannerImageListResponseData, i: any) => {
          let imgurl = imageskinbanner.path.replaceAll("\\", "/")
          this.imagePreview_skin_banner.push(imgurl);
        })
      }
    })
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get home_supliment_banner image
  * @param code :-  This param is used to get home_supliment_banner image
  */
  async getSupplimentBannerImages(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imagesupplimentbanner: MBannerImageListResponseData, i: any) => {
          this.imagePreview_suppliment_banner.push(imagesupplimentbanner.path);
        })
      }
    })
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get Customer menu List  With Details
  */
  async getCustomerMenuList() {
    const customerMenuListData = this.wsSubheaderService.getCustomerMenuList();
    await lastValueFrom(customerMenuListData).then(response => {
      if (response && response.statusCode == 200) {
        if (response.data.categoryList && response.data.categoryList.length > 0) {
          this.categoryList = response.data.categoryList;
          if (this.categoryList.length > 0) {
            this.selectedCategoryId = this.categoryList[0].id
            this.getSubCategory(this.categoryList[0])
          }
          this.categorySkin = response.data.categoryList?.filter((category: MCustomerMenuCategoryResponse) => (category.name?.toLocaleLowerCase() === "skin"));
          this.categoryMakeup = response.data.categoryList?.filter((category: MCustomerMenuCategoryResponse) => (category.name?.toLocaleLowerCase() === "makeup"));
        }

      }
    })
  }

  /**
  * Date:- 10-06-2023
  * Method :- This method is used to get Trending Products
  * @param trendingProductReq :-  This param is used to get Trending Products
  */
  async getTrendingProduct(trendingProductReq: any) {
    const listTrendingProduct = this.wslandingservice.getTrendingPoduct(trendingProductReq)
    await lastValueFrom(listTrendingProduct).then(async response => {
      if (response && response.statusCode == 200) {
        this.trendingProducts = response.data
        this.trendingProducts.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          }
        })
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.trendingProducts.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      }
    })
  }

  /**
  * Date:- 10-06-2023
  * Method :- This method is used to get Suppliment Products
  * @param suppimentReq :-  This param is used to get Suppliment Products
  */
  async getSuppliments(suppimentReq: any) {
    const listSuppliment = this.wslandingservice.getPoductByGenderSuppiment(suppimentReq)
    await lastValueFrom(listSuppliment).then(async response => {
      if (response && response.statusCode == 200) {
        this.supplimentProducts = response.data
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.supplimentProducts.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.supplimentProducts.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      }
    })
  }


  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  async addToCartCommon(product: any, index?: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    this.mAddUpdateCartModule.product_id = product.id;
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
      if (product.like) {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
      this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          if (productType == 'suppliment') {
            this.supplimentProducts[index].like = product.like ? false : true;
          }
          if (productType == 'trending') {
            this.trendingProducts[index].like = product.like ? false : true;
          }
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  async addtoCart(product: any, val: any, index?: any, productType?: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product, index, productType)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product, index, productType)
        }
      })
    }
  }


  goToShopAll(val: any, catId: any, subId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all/" + val], {
      queryParams: {
        c: catId,
        sub: subId
      }
    })
  }

  goToProductList(val: any) {
    this.router.navigate(["/product-list/" + val])
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  async getCategoryList() {
    const categoryListData = this.wsblogservice.getCategoryByType(2);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
      } else {
      }
    })
  }
  async getCategoryListType1() {
    const categoryListData = this.wsblogservice.getCategoryByType(1);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
        this.hairCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'HAIR'))
        this.getAllSubCategory(this.hairCatId.id, this.hairCatId.category_code)
      } else {
      }
    })
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  async addCartItem(product: any, index: any, type: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    if (type == 'suppliment') {
      this.supplimentProducts[index]['cartQty'] = this.supplimentProducts[index]['cartQty'] + 1
      this.mAddUpdateCartModule.qty = this.supplimentProducts[index]['cartQty']
    } else {
      this.trendingProducts[index]['cartQty'] = this.trendingProducts[index]['cartQty'] + 1
      this.mAddUpdateCartModule.qty = this.trendingProducts[index]['cartQty']
    }
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  async removeCartItem(product: any, index: any, type: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    if (product.cartQty > 0) {
      if (type == 'suppliment') {
        this.supplimentProducts[index]['cartQty'] = this.supplimentProducts[index]['cartQty'] - 1
        this.mAddUpdateCartModule.qty = this.supplimentProducts[index]['cartQty']
      } else {
        this.trendingProducts[index]['cartQty'] = this.trendingProducts[index]['cartQty'] - 1
        this.mAddUpdateCartModule.qty = this.trendingProducts[index]['cartQty']
      }
    } else {
      this.mAddUpdateCartModule.qty = 0;
      if (type == 'suppliment') {
        delete this.supplimentProducts[index]['cartQty']
      } else {
        delete this.trendingProducts[index]['cartQty']
      }
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  getSubCategory(cat: any) {
    this.selectedCategoryId = cat.id;
    this.catName = cat.name;
    this.subCategoryList = cat.subCategoriesList;
    this.categoryColor = 'linear-gradient(315deg,' + cat.categoryDetails.color + ' 0%, #ffffff 100%)'
  }

  handleImageError(img: any) {
    img.target.src = "assets/images/no-image-png.png";
    img.onerror = null; // Remove onerror to prevent infinite loop
  }

  async getSkinConcernList() {
    const warehouseList = this.wsBrandService.getSkinConcernList()
    await lastValueFrom(warehouseList).then(response => {
      if (response && response.statusCode == 200) {
        this.mGetSkinConcernResponse.data = response.data;
        this.skinConcernList = this.mGetSkinConcernResponse.data.filter((sc: any) => sc.tags && sc.tags.indexOf(this.troubleSkinConcern[0].id) != -1)
      } else {
      }
    })
  }

  async getSkinTypeList() {
    const warehouseList = this.wsBrandService.getSkinTypeList()
    await lastValueFrom(warehouseList).then(response => {
      if (response && response.statusCode == 200) {
        this.mGetSkinTypeResponse.data = response.data;
        this.skinTypeList = this.mGetSkinTypeResponse.data.filter((st: any) => st.tags && st.tags.indexOf(this.shopBySkinType[0].id) != -1)
      } else {
      }
    })
  }

  /**
    * to get trending blog list
    */
  async getTrendingBlogList() {
    this.trendingBlogs = [];
    const trendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(trendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        response.data.forEach((blog: any) => {
          if (this.trendingBlogs.length < 1) {
            this.trendingBlogs = blog.blogs;
          } else {
            this.trendingBlogs = [...this.trendingBlogs, ...blog.blogs];
          }
        })
      } else {
      }
    })
  }

  getBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }

  async getAllSubCategory(catId: any, category_code: any) {
    this.mCommonListModalRequest.take = 100;
    if (this.mCommonListModalRequest.skip == 0) {
      this.hairSubCategoryList = []
    }
    this.mCommonListModalRequest.categoryIds = "" + catId;
    const getAllSubCategory = this.wsShopAllService.getAllSubCategory(this.mCommonListModalRequest)
    await lastValueFrom(getAllSubCategory).then(async response => {
      if (response && response.statusCode == 200) {
        this.hairSubCategoryList = response.data;
      } else {
      }
    })
  }

  async getAllBrand() {
    this.mCommonListModalRequest = new MCommonListModalRequest()
    this.mCommonListModalRequest.take = 1000
    this.mCommonListModalRequest.isAllowInactive = false;
    const getAllBrand = this.wsShopAllService.getAllBrand(this.mCommonListModalRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data;
        this.firstBrandList = this.mGetBrandResponse.data.slice(0, this.mGetBrandResponse.data.length / 2);
        await this.firstBrandList.forEach(async (brand: any) => {
          await brand.imageList && brand.imageList.forEach((image: any) => {
            if (image.type == 'brand_logo_image') {
              brand['logo_image'] = image.path;
            }
          })
        })
        this.secondBrandList = this.mGetBrandResponse.data.slice(this.mGetBrandResponse.data.length / 2, this.mGetBrandResponse.data.length);
        await this.secondBrandList.forEach(async (brand: any) => {
          await brand.imageList && brand.imageList.forEach((image: any) => {
            if (image.type == 'brand_logo_image') {
              brand['logo_image'] = image.path;
            }
          })
        })
      } else {
      }
    })
  }



  async getAllTag() {
    const getAllTag = this.wsShopAllService.getAllTags()
    await lastValueFrom(getAllTag).then(async response => {
      if (response && response.statusCode == 200) {
        this.getAlltags = response.data;
        this.troubleSkinConcern = this.getAlltags.filter((tag: any) => tag.title.toLowerCase() == "WHAT'S TROUBLING YOU?".toLowerCase())
        this.shopBySkinType = this.getAlltags.filter((tag: any) => tag.title.toLowerCase() == "SHOP BY SKIN TYPE".toLowerCase())
      }
    })
  }

  /**
     * Date: 10-06-23
     * Method: This method is used to get all product by parameter passed
     */
  async getMakeupProducts() {
    let mGetProductRequest = new MGetProductRequest();
    const favoritesTag = this.getAlltags.find((tag: any) => tag.title.toLowerCase() === 'MAKE UP ON THE GO'.toLowerCase());
    if (favoritesTag) {
      mGetProductRequest.tags = favoritesTag.id.toString();
    } else {
      mGetProductRequest.tags = '';
      return;
    }
    mGetProductRequest.take = 12
    const getAllProductByTags = this.wsShopAllService.getAllProductByTags(mGetProductRequest.tags)
    await lastValueFrom(getAllProductByTags).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;
      this.makupProducts = []
      if (this.makupProducts && this.makupProducts.length < 1) {
        this.makupProducts = response.data.slice(0, 12);
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.makupProducts.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.makupProducts.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
              product.cartQty = cartPresent.qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.makupProducts = [...this.makupProducts, ...response.data];
      }
      this.makupProducts = this.makupProducts.filter((item: any) => {
        if (!item?.category?.is_active || !item?.subCategory?.is_active || !item?.brand?.is_active || !item?.is_active) {
          return false;
        }
        return true;
      })
    })
  }

  /**
   * Date: 22-11-23
   * Method: This method is used to get all Tags
   */

  /**
   * Date: 10-06-23
   * Method: This method is used to get all product by parameter passed
   */
  async getFavouritesProducts() {
    this.mGetProductRequest = new MGetProductRequest();
    const favoritesTag = this.getAlltags.find((tag: any) => tag.title.toLowerCase() === 'FOY FAVOURITES'.toLowerCase());
    if (favoritesTag) {
      this.mGetProductRequest.tags = favoritesTag.id.toString();
    } else {
      this.mGetProductRequest.tags = '';
      return;
    }
    const getAllProductByTags = this.wsShopAllService.getAllProductByTags(this.mGetProductRequest.tags)
    await lastValueFrom(getAllProductByTags).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;
      this.tagsProducts = []
      if (this.tagsProducts && this.tagsProducts.length < 1) {
        this.tagsProducts = response.data.slice(0, 12);
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.tagsProducts.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.tagsProducts.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
              product.cartQty = cartPresent.qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.tagsProducts = [...this.tagsProducts, ...response.data];
      }
      this.tagsProducts = this.tagsProducts.filter((item: any) => {
        if (!item?.category?.is_active || !item?.subCategory?.is_active || !item?.brand?.is_active || !item?.is_active) {
          return false;
        }
        return true;
      })
    })
  }

  /**
  * Date: 10-06-23
  * Method: This method is used to get subcategory , skintype and skin concern of selected category
  */
  async getAllModuleDataOfShopAll() {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("2")
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.categoryDetails = response.data.categoryDetails[0]
      } else {
      }
    })
  }

  async getAllWebsiteconfigurations() {
    const getAllWebsiteconfigurations = this.wsShopAllService.getAllWebsiteconfigurations(this.mCommonListModalRequest)
    await lastValueFrom(getAllWebsiteconfigurations).then(async response => {
      if (response && response.statusCode == 200) {
        this.websiteconfigurations = []
        this.websiteconfigurations = response['data']
        this.websiteconfigurations.forEach((wc: any) => {
          if (wc.configurationskey == 'website_configuration') {
            this.website_configuration = JSON.parse(wc.configurationsvalue)
          }
          if (wc.configurationskey == 'home_first_text') {
            this.home_first_text = wc.configurationsvalue
          }
          if (wc.configurationskey == 'some_text_cta') {
            this.some_text_cta = wc.configurationsvalue
          }
        })
      }
    });
  }

  async getAllDiscountCatelogue() {
    this.mCommonListModalRequest.take = 10;
    this.allUnderDiscountCatelogue = [];
    this.offersDiscountCatelogue = [];
    const getAllDiscount = this.wsCheckoutService.getAllDiscountCatelogue(this.mCommonListModalRequest)
    await lastValueFrom(getAllDiscount).then(async response => {
      if (response && response.statusCode == 200) {
        this.discountCatelogueList = response['data'];
        await response['data'].forEach((discountCateloge: any) => {
          if (discountCateloge.type == 'all_under') {
            this.allUnderDiscountCatelogue.push(discountCateloge);
          }
          if (discountCateloge.type == 'offers') {
            this.offersDiscountCatelogue.push(discountCateloge);
          }
        })
      }
    });
  }

  showImage(image: any) {
    return image;
  }

  redirectToShopAll(url: any) {
    this.router.navigate([url])
  }

  viewAllOffers() {
    this.router.navigate(['offers'])
  }

  viewAllFavourites() {
    this.router.navigate(['shop-all/favourites/22'])
  }

  viewBrandDetail(brand: MBrandListModal) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/individual-brand/" + brand.name.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')], {
      queryParams: {
        b: (brand.id || brand.code)
      }
    })
  }

  goToShopAllWithSkinConcern(val: any, catId: any, skinConcernId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], {
      queryParams: {
        sc: skinConcernId
      }
    })
  }

  goToShopAllWithSkinType(val: any, catId: any, skinTypeId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], {
      queryParams: {
        st: skinTypeId
      }
    })
  }



  async openBlogDetail(val: any) {
    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }

  async showAllTrending() {
    this.router.navigate(["/blog"])
  }

  getUserId() {
    this.userId = SharedPrefrences.getUserId()
  }

  profileClick(val: any) {
    this.userId = SharedPrefrences.getUserId();
    if (this.userId == '' || this.userId == null) {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.userId = SharedPrefrences.getUserId();
          window.location.reload()
        }
      })
    } else {
      if (val) {
        window.location.reload()
      }
    }
  }

  openUserProfile() {
    this.userId = SharedPrefrences.getUserId();
    if (this.isMobile) {
      this.router.navigate(['/user-your-profile']);
    } else {

      this.router.navigate(['user/' + this.userId])
    }
  }
  checkAllArrow() {
    if (this.favProduct) {
      let container = this.favProduct.nativeElement;
      this.showFavLeftArrow = container.scrollLeft > 0;
      this.showFavRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
    }
    if (this.hairProduct) {
      let haircontainer = this.hairProduct.nativeElement;
      this.showHairLeftArrow = haircontainer.scrollLeft > 0;
      this.showHairRightArrow = haircontainer.scrollWidth > haircontainer.clientWidth + haircontainer.scrollLeft;
    }
    if (this.makeupProduct) {
      let makecontainer = this.makeupProduct.nativeElement;
      this.showMakeupLeftArrow = makecontainer.scrollLeft > 0;
      this.showMakeupRightArrow = makecontainer.scrollWidth > makecontainer.clientWidth + makecontainer.scrollLeft;
    }
    if (this.trendingblog) {
      let trendingcontainer = this.trendingblog.nativeElement;
      this.showTrendinLeftArrow = trendingcontainer.scrollLeft > 0;
      this.showTrendinRightArrow = trendingcontainer.scrollWidth > trendingcontainer.clientWidth + trendingcontainer.scrollLeft;
    }
  }
  checkScroll(id: any) {
    switch (id) {
      case 'favProduct':
        let container = this.favProduct.nativeElement;
        this.showFavLeftArrow = container.scrollLeft > 0;
        this.showFavRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
        break;
      case 'makeupProduct':
        let makecontainer = this.makeupProduct.nativeElement;
        this.showMakeupLeftArrow = makecontainer.scrollLeft > 0;
        this.showMakeupRightArrow = makecontainer.scrollWidth > makecontainer.clientWidth + makecontainer.scrollLeft;
        break;
      case 'hairProduct':
        let haircontainer = this.hairProduct.nativeElement;
        this.showHairLeftArrow = haircontainer.scrollLeft > 0;
        this.showHairRightArrow = haircontainer.scrollWidth > haircontainer.clientWidth + haircontainer.scrollLeft;
        break;
      case 'trendingblog':
        let trendingcontainer = this.trendingblog.nativeElement;
        this.showTrendinLeftArrow = trendingcontainer.scrollLeft > 0;
        this.showTrendinRightArrow = trendingcontainer.scrollWidth > trendingcontainer.clientWidth + trendingcontainer.scrollLeft;
        break;

      default:
        break;
    }
  }


  goRight(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'right', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }


  goLeft(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'left', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }

  sideScroll(element: any, direction: any, speed: any, distance: any, step: any) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  setHoveredBtn(btn: string) {
    this.hoveredBtn = btn;
  }

  resetHoveredBtn() {
    this.hoveredBtn = null;
  }

}

